<template>
  <div class="content-colors">
    <h3 class="heading">
      {{ name }}
    </h3>
    <ul class="list" v-if="colors && colors.length > 0">
      <li
        v-for="color in colors"
        :key="color.id"
        :class="{ 'current': color.id === value }"
      >
        <div class="item-color" @click="() => handleItemClick(color)">
          <i class="check-icon check-icon--low"></i>
          <div class="zoom-img">
            <img class="coverImage" :src="color.photo">
            <span class="title">{{ color.name }}</span>
          </div>
          <img class="img-fluid" :src="color.photo">
        </div>
      </li>
    </ul>
    <div class="content-text" v-if="description">
      <p v-html="description"></p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ColorsGroup',
    props: {
      id: {},
      value: [String, Number],
      name: String,
      colors: Array,
      description: String,
    },
    methods: {
      handleItemClick(color) {
        this.$emit('change', color);
      },
    },
  };
</script>

